function ServiceCard(props) {
    return (
        <div className="flex flex-col items-center justify-top gap-4 p-8 bg-white w-64 h-64 rounded-lg">
            {props.children}
        </div>
    )
}

export default ServiceCard